import { LGBTButton } from '../../components/lgbtButton/LGBTButton'
import styles from './ProfilePage.module.css'
export const LogOut = ({onLogOut}:{onLogOut:()=>void}) =>{
    return(
    <div className={styles.profile_page_logout_modal}>
        <div style={{textAlign:"center"}}>
            Вы уверены что хотите выйти из профиля?
        </div>

        <LGBTButton
        onClick={()=>{onLogOut()}}
        text='ВЫЙТИ'/>

    </div>)
}